var jCube = require('./core');
var vars = require('./variables');

jCube.type = function( obj ) {
    if ( obj == null ) {
        return obj + "";
    }
    // Support: Android<4.0, iOS<6 (functionish RegExp)
    return typeof obj === "object" || typeof obj === "function" ?
        vars.class2type[ vars.toString.call(obj) ] || "object" :
        typeof obj;
};

jCube.isIE = function() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
};

jCube.isWindow = function (obj) {
    return !!obj && obj === obj.window;
};

jCube.isArray = Array.isArray;

jCube.isEmptyObject = function( obj ) {
    var name;
    for ( name in obj ) {
        return false;
    }
    return true;
};

jCube.isArraylike = function( obj ) {
    var length = obj.length,
        type = jCube.type( obj );

    if ( type === "function" || jCube.isWindow( obj ) ) {
        return false;
    }

    if ( obj.nodeType === 1 && length ) {
        return true;
    }

    return type === "array" || length === 0 ||
        typeof length === "number" && length > 0 && ( length - 1 ) in obj;
};

jCube.isNumeric = function( obj ) {
    return !jCube.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
};

jCube.isPlainObject = function( obj ) {
    // Not plain objects:
    // - Any object or value whose internal [[Class]] property is not "[object Object]"
    // - DOM nodes
    // - window
    if ( jCube.type( obj ) !== "object" || obj.nodeType || jCube.isWindow( obj ) ) {
        return false;
    }

    if ( obj.constructor &&
        !vars.hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
        return false;
    }

    // If the function hasn't returned already, we're confident that
    // |obj| is a plain object, created by {} or constructed with new Object
    return true;
};

jCube.isDocument = function(obj) {
    return !!obj && obj.nodeType === 9;
};

jCube.isElement = function(obj) {
    return !!obj && obj.nodeType === 1;
};

jCube.isInArray = function(key, array) {
    return array.indexOf(key) > -1;
};

jCube.inArray = function( elem, arr, i ) {
    return arr == null ? -1 : vars.indexOf.call( arr, elem, i );
};

jCube.isEmptyValue = function(key, obj) {

    if(obj === void 0) {
        obj = key;

    } else if (typeof obj[key] === 'undefined') {
        return true

    } else {
        obj = obj[key];
    }

    return obj === null || obj === {} || obj === [] || obj === '';
};

jCube.isString = function(obj) {
    return typeof obj === 'string';
};

jCube.isFunction = function(obj) {
    return typeof obj === 'function';
};

jCube.isHidden = function (obj) {
    return this.computeStyle(obj, 'display') === 'none';
};

jCube.isCubeJS = function(obj) {
    return obj instanceof jCube;
};

jCube.IsJson = function(json) {
    var str = json.toString();
    try{
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

jCube.isBoolean = function (obj) {
    return typeof obj === "boolean";
}